(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();
})();
